import { useState, useEffect } from "react";

export default function useCarouselNavigation(videosLength) {
  const [activeIndex, setActiveIndex] = useState(0);

  const goToPrevious = () => {
    setActiveIndex((prev) => (prev > 0 ? prev - 1 : videosLength - 1));
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev < videosLength - 1 ? prev + 1 : 0));
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goToPrevious();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        goToNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  return {
    activeIndex,
    setActiveIndex,
    goToPrevious,
    goToNext,
  };
}
